<template>
  <layout-blank>
    <div class="lang-select d-flex">
      <app-bar-theme-switcher></app-bar-theme-switcher>
      <app-bar-notification v-if="isLoggedIn"></app-bar-notification>
      <app-bar-i18n></app-bar-i18n>
    </div>
    <slot></slot>
  </layout-blank>
</template>

<script>
import LayoutBlank from '@/@core/layouts/variants/blank/LayoutBlank.vue'
import AppBarThemeSwitcher from '@core/layouts/components/app-bar/AppBarThemeSwitcher.vue'
import AppBarI18n from '@core/layouts/components/app-bar/AppBarI18n.vue'
import AppBarNotification from '@core/layouts/components/app-bar/AppBarNotification.vue'

export default {
  components: {
    LayoutBlank,
    AppBarThemeSwitcher,
    AppBarI18n,
    AppBarNotification,
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters['session/logged']()
    },
  },
  // mounted() {
  //   console.log(this.isLoggedIn)
  // },
}
</script>

<style scoped>
.lang-select {
  position: absolute;
  right: 0;
  top: 0;
  margin-right: 20px;
  margin-top: 10px;
  z-index: 1;
}
</style>
